<div class="container single-view" id="edit-retailer">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" appBack [fallbackUrl]="'/retailers/' + retailerId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'RETAILERS.BTN_BACK_TO_RETAILER' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr">
        <div class="title-wr">
          <h1 data-testid="edit-retailer-title" class="section-title">{{ 'RETAILER_UPDATE.TITLE' | translate }}</h1>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form class="mt-0" [formGroup]="retailerForm" data-testid="edit-retailer-form">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="edit-retailer-details-title" class="border-b pb-3">{{ 'RETAILER_CREATE.BASIC_INFO' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-name" class="block text-sm" for="retailerName">{{ 'RETAILER_CREATE.NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="edit-retailer-name-input" type="text" formControlName="retailerName" autocomplete="off">
                  @if (retailerForm.get('retailerName')?.invalid && retailerForm.get('retailerName')?.touched) {
                    <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-romanisedname" class="block text-sm" for="romanisedName">{{ 'RETAILER_CREATE.NAME_ROMANIZED' | translate
                  }}</label>
                  <input data-testid="edit-retailer-romanisedname-input" type="text" formControlName="romanisedName" autocomplete="off">
                  @if (retailerForm.get('romanisedName')?.invalid && (retailerForm.get('romanisedName')?.dirty || retailerForm.get('romanisedName')?.touched)) {
                    <div class="error-hint-wr"
                      >
                      @if (retailerForm.get('romanisedName')?.errors?.['invalidCharacters']) {
                        <small class="p-error">
                          {{ 'USER_CREATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                        </small>
                      }
                    </div>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-externalid" class="block text-sm" for="externalRetailerId">{{ 'RETAILER_CREATE.EXTERNAL_RETAILER_ID' |
                  translate }}</label>
                  <input data-testid="edit-retailer-externalid-input" type="text" formControlName="externalRetailerId" autocomplete="off">
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-code" class="block text-sm" for="code">{{ 'RETAILER_CREATE.CODE' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="edit-retailer-code-input" type="text" formControlName="code" autocomplete="off">
                  @if (retailerForm.get('code')?.invalid && retailerForm.get('code')?.touched) {
                    <small data-testid="code-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
              </div>

              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 class="border-b pb-3">{{ 'RETAILER_CREATE.LOCATION_DETAILS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-street" class="block text-sm" for="street">{{ 'RETAILER_CREATE.STREET' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="edit-retailer-street-input" type="text" formControlName="street" autocomplete="off">
                  @if (retailerForm.get('street')?.invalid && retailerForm.get('street')?.touched) {
                    <small data-testid="street-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-zipcode" class="block text-sm" for="zipCode">{{ 'RETAILER_CREATE.ZIP_CODE' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="edit-retailer-zipcode-input" type="text" formControlName="zipCode" autocomplete="off">
                  @if (retailerForm.get('zipCode')?.invalid && retailerForm.get('zipCode')?.touched) {
                    <small data-testid="zipcode-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-city" class="block text-sm" for="city">{{ 'RETAILER_CREATE.CITY' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="edit-retailer-city-input" type="text" formControlName="city" autocomplete="off">
                  @if (retailerForm.get('city')?.invalid && retailerForm.get('city')?.touched) {
                    <small data-testid="city-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-cityromanised" class="block text-sm" for="cityRomanized">{{ 'RETAILER_CREATE.CITY_ROMANIZED' | translate }}</label>
                  <input data-testid="edit-retailer-cityromanised-input" type="text" formControlName="cityRomanized" autocomplete="off">
                  @if (retailerForm.get('cityRomanized')?.invalid && (retailerForm.get('cityRomanized')?.dirty || retailerForm.get('cityRomanized')?.touched)) {
                    <div class="error-hint-wr"
                      >
                      @if (retailerForm.get('cityRomanized')?.errors?.['invalidCharacters']) {
                        <small class="p-error">
                          {{ 'USER_CREATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                        </small>
                      }
                    </div>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-stateprovince" class="block text-sm" for="stateProvince">{{ 'RETAILER_CREATE.STATE_PROVINCE' | translate }}</label>
                  <input data-testid="edit-retailer-stateprovince-input" type="text" formControlName="stateProvince" autocomplete="off">
                  @if (retailerForm.get('stateProvince')?.invalid && retailerForm.get('stateProvince')?.touched) {
                    <small data-testid="stateprovince-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-stateprovinceromanised" class="block text-sm" for="stateProvinceRomanized">{{ 'RETAILER_CREATE.STATE_PROVINCE_ROMANIZED' | translate }}</label>
                  <input data-testid="edit-retailer-stateprovinceromanised-input" type="text" formControlName="stateProvinceRomanized" autocomplete="off">
                  @if (retailerForm.get('stateProvinceRomanized')?.invalid && (retailerForm.get('stateProvinceRomanized')?.dirty || retailerForm.get('stateProvinceRomanized')?.touched)) {
                    <div class="error-hint-wr"
                      >
                      @if (retailerForm.get('stateProvinceRomanized')?.errors?.['invalidCharacters']) {
                        <small class="p-error">
                          {{ 'USER_CREATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                        </small>
                      }
                    </div>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-country" class="block text-sm" for="country">{{ 'RETAILER_CREATE.COUNTRY' | translate }} <i class="icon-required-field"></i></label>
                  <app-custom-dropdown
                    data-testid="edit-retailer-country-input"
                    [optionTestIdPrefix]="'listbox-item-'"
                    [options]="countries"
                    optionLabel="translationKey"
                    optionValue="alpha2"
                    [translateOptionLabel]="true"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showSearchbox]="true"
                    [showClear]="true"
                    [searchMode]="'local'"
                    [pageSize]="10"
                    [placeholder]="'RETAILER_CREATE.COUNTRY' | translate"
                    formControlName="country">
                  </app-custom-dropdown>
                  @if (retailerForm.get('country')?.invalid && retailerForm.get('country')?.touched) {
                    <small data-testid="country-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-latitude" class="block text-sm" for="latitude">{{ 'RETAILER_CREATE.LATITUDE' | translate }}</label>
                  <input data-testid="edit-retailer-latitude-input" type="text" formControlName="latitude" autocomplete="off">
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-longitude" class="block text-sm" for="longitude">{{ 'RETAILER_CREATE.LONGITUDE' | translate }}</label>
                  <input data-testid="edit-retailer-longitude-input" type="text" formControlName="longitude" autocomplete="off">
                </div>
              </div>

              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 class="border-b pb-3">{{ 'RETAILER_CREATE.BUSINESS_DETAILS' | translate }}</h2>
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-brands" class="block text-sm" for="brandIds">
                    {{ 'RETAILER_CREATE.BRANDS' | translate }}
                  </label>
                  <app-custom-dropdown
                    data-testid="brands"
                    [placeholder]="'RETAILER_CREATE.SELECT_BRANDS' | translate"
                    [fieldLabel]="'RETAILER_CREATE.BRANDS' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="true"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['brands'].rowsPerPageOption || 5"
                    [totalCount]="combosData['brands'].totalRecords"
                    [totalPages]="getComboTotalPages('brands')"
                    [options]="combosData['brands'].list"
                    formControlName="brandIds"
                    (onLazyLoad)="onLazyLoadComboData('brands', $event)">
                  </app-custom-dropdown>
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-retailertype" class="block text-sm" for="retailer-types">{{ 'RETAILER_CREATE.RETAILER_TYPE' | translate }}</label>
                  <app-custom-dropdown
                    data-testid="retailertype"
                    [placeholder]="'RETAILER_CREATE.SELECT_RETAILER_TYPE' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['retailerTypes'].rowsPerPageOption || 5"
                    [totalCount]="combosData['retailerTypes'].totalRecords"
                    [totalPages]="getComboTotalPages('retailerTypes')"
                    [options]="combosData['retailerTypes'].list"
                    formControlName="retailerTypeId"
                    (onLazyLoad)="onLazyLoadComboData('retailerTypes', $event)">
                  </app-custom-dropdown>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label ata-testid="edit-retailer-field-market" class="block text-sm" for="marketCode">{{ 'RETAILER_CREATE.MARKET_CODE' | translate }} <i class="icon-required-field"></i></label>
                  <app-custom-dropdown
                    data-testid="market"
                    [placeholder]="'RETAILER_CREATE.SELECT_MARKET' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['markets'].rowsPerPageOption || 5"
                    [totalCount]="combosData['markets'].totalRecords"
                    [totalPages]="getComboTotalPages('markets')"
                    [options]="combosData['markets'].list"
                    formControlName="marketId"
                    (onLazyLoad)="onLazyLoadComboData('markets', $event)">
                  </app-custom-dropdown>
                  @if (retailerForm.get('marketId')?.invalid && retailerForm.get('marketId')?.touched) {
                    <small data-testid="market-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>

                @if(showDistributionChannel){
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-distributionchannels" class="block text-sm" for="retailer-types">{{ 'RETAILER_CREATE.DISTRIBUTION_CHANNEL' | translate }} <i class="icon-required-field"></i></label>
                  <app-custom-dropdown
                    data-testid="distributionchannel"
                    [placeholder]="'RETAILER_CREATE.SELECT_DISTRIBUTION_CHANNEL' | translate"
                    [fieldLabel]="'RETAILER_CREATE.SELECT_DISTRIBUTION_CHANNEL' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="true"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="combosData['distributionChannels'].rowsPerPageOption || 5"
                    [totalCount]="combosData['distributionChannels'].totalRecords"
                    [totalPages]="getComboTotalPages('distributionChannels')"
                    [options]="combosData['distributionChannels'].list"
                    formControlName="distributionChannelIds"
                    (onLazyLoad)="onLazyLoadComboData('distributionChannels', $event)">
                  </app-custom-dropdown>
                  @if (retailerForm.get('distributionChannelIds')?.invalid && retailerForm.get('distributionChannelIds')?.touched) {
                    <small data-testid="distributionchannels-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                }

                @if (showBusinessGroup) {
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-retailer-field-businessgroup" class="block text-sm" for="businessGroupId">{{ 'RETAILER_CREATE.BUSINESS_GROUP' | translate }}</label>
                    <app-custom-dropdown
                      data-testid="businessgroup"
                      [placeholder]="'RETAILER_CREATE.SELECT_BUSINESS_GROUP' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="false"
                      [showSelectionChips]="true"
                      [showClear]="true"
                      [searchMode]="'remote'"
                      [pageSize]="combosData['businessGroups'].rowsPerPageOption || 5"
                      [totalCount]="combosData['businessGroups'].totalRecords"
                      [totalPages]="getComboTotalPages('businessGroups')"
                      [options]="combosData['businessGroups'].list"
                      formControlName="businessGroupId"
                      (onLazyLoad)="onLazyLoadComboData('businessGroups', $event)">
                    </app-custom-dropdown>
                  </div>
                }
              </div>
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 class="border-b pb-3">{{ 'RETAILER_CREATE.OPERATIONAL_INFO' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-openingdate" class="block text-sm" for="openingDate">{{ 'RETAILER_CREATE.OPENING_DATE' | translate
                  }}</label>
                  <p-datepicker data-testid="edit-retailer-openingdate-input" formControlName="openingDate" showIcon="true" [hourFormat]="'24'"  dateFormat="dd-mm-yy" placeholder="{{ 'RETAILER_CREATE.OPENING_DATE' | translate}}" />
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-closingdate" class="block text-sm" for="closingDate">{{ 'RETAILER_CREATE.CLOSING_DATE' | translate
                  }}</label>
                  <p-datepicker data-testid="edit-retailer-closingdate-input" formControlName="closingDate" showIcon="true" [hourFormat]="'24'" dateFormat="dd-mm-yy" placeholder="{{ 'RETAILER_CREATE.CLOSING_DATE' | translate}}" />
                </div>
                @if (companyHasCpo) {
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <div class="row">
                      <div class="col-12">
                        <span data-testid="edit-retailer-field-hascpo" class="mb-2 block text-sm" for="hasCpo">{{ 'RETAILER_CREATE.CPO' | translate }}</span>
                        <label data-testid="edit-retailer-has-hascpo-yes-label" class="inline-flex mr-6">
                          <p-radioButton data-testid="edit-retailer-has-hascpo-yes" name="hasCpo" value="true" formControlName="hasCpo" inputId="yes" />
                          <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                        </label>
                        <label data-testid="edit-retailer-has-hascpo-no-label" class="inline-flex mr-2">
                          <p-radioButton data-testid="edit-retailer-has-hascpo-no" name="hasCpo" value="false" formControlName="hasCpo" inputId="no" />
                          <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                }
              </div>

              <!-- Dynamic retailer attributes -->
              @if (retailerAttributesFeatureEnabled && retailerAttributeDefinitions.length) {
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 class="border-b pb-3">
                    {{ 'RETAILER_CREATE.ATTRIBUTES' | translate }}
                  </h2>
                </div>
                <div class="col-12">
                  <app-attribute-values-form
                    #retailerAttributeValuesForm
                    [definitions]="retailerAttributeDefinitions"
                    [initialSelections]="retailerAttributeSelections"
                    fieldIdPrefix="retailer-attribute">
                  </app-attribute-values-form>
                </div>
              </div>
              }

              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 class="border-b pb-3">{{ 'RETAILER_CREATE.CONTACT_INFORMATION' | translate }}</h2>
                </div>

                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-retailer-field-email" class="block text-sm" for="email">{{ 'RETAILER_CREATE.EMAIL' | translate }}</label>
                  <input data-testid="edit-retailer-email-input" type="text" formControlName="email" autocomplete="off">
                </div>
                <div class="field-wr flex flex-col col-12">
                  <label data-testid="edit-retailer-field-comments" class="block text-sm" for="comments">{{ 'RETAILER_CREATE.COMMENTS' | translate }}</label>
                  <textarea data-testid="edit-retailer-comments-input" type="text" formControlName="comments" autocomplete="off"></textarea>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="edit-retailer-update-retailer-button" class="btn primary-btn" pButton [disabled]="retailerForm.invalid"
                    (click)="submitForm()">{{ 'RETAILER_UPDATE.BTN_UPDATE_RETAILER' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
